module.exports = __webpack_public_path__ + "static/media/about.a982db39.JPEG";